import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import advancedPotionMaking from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy";
import advancedPotionMakingV2 from "assets/replicas/harry-potter/hp-advanced-potion-making/edition-II-prince's-copy/v2";
import backgroundImage from "./gallery/promo_02.jpg";
import { routes } from "config";

let gallery = [];
let gallery2 = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
  gallery2 = importAll(
    (require as any).context("./gallery-2", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.1,
};

const Page = () => {
  const galleryImages = transformImages(gallery);
  const galleryImages2 = transformImages(gallery2);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        This is the entire text block of{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", advancedPotionMaking.id).replace(":version", `v${advancedPotionMakingV2.version}`)}`}
          target="_blank"
        >
          Advanced Potion-Making v2
        </Link>{" "}
        with the content 1:1 to the final prop - however - there is one
        difference, that being this text block is a bit taller than the final
        one. That is the only reason it is marked as 'prototype' as to not
        confuse anyone. The company accidentally delivered me the wrong grammage
        of the book paper. Unfortunately, you can't really tell a few grams
        being off just by handling the paper sheets, so I noticed the final
        block was taller than it was supposed to be only after I fully completed
        the binding.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={3}
        aspectRatio={1}
        imageMaxHeight="200px"
        imageOptions={[
          { index: 1, aspectRatio: 1.7 },
          { index: 2, aspectRatio: 1.7 },
        ]}
      />
      <ReplicaSpacer />

      <ReplicaParagraph>
        That said, it is still 100% useable for a one-off replica of the book —
        as you can see in the images below, the only visible difference is the
        height of the text block compared to the final v2. If you wanted to use
        this for a complete replica, you would just need a bit wider spine for
        the cover (though please note I do not offer such cover).
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages2}
        imagesPerRow={4}
        aspectRatio={1}
        imageMaxHeight="300px"
      />
      <ReplicaSpacer />
    </ReplicaContent>
  );
};

export default Page;
export { background };
